import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import SettingsModal from '@/components/SettingsModal';

export default function SettingsPage() {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!workspaceId) navigate('/dashboard');
  }, [workspaceId, navigate]);

  if (!workspaceId) return null;

  return (
    <SettingsModal
      open={true}
      onClose={() => navigate(`/roadmap/${workspaceId}`)}
      workspaceId={workspaceId}
    />
  );
}
